import React, { Component } from 'react';
import { ItemGroup } from '@atlaskit/item';
export default class DropdownItemGroup extends Component {
    render() {
        const { children, elemAfter, title } = this.props;
        return (React.createElement(ItemGroup, { elemAfter: elemAfter, title: title, role: "menu" }, children));
    }
}
//# sourceMappingURL=DropdownItemGroup.js.map